var map = {
	"./classica.png": 882,
	"./classica_dark.png": 883,
	"./karaoke.png": 884,
	"./karaoke_dark.png": 885,
	"./music.png": 886,
	"./music_dark.png": 887,
	"./qello.png": 888,
	"./qello_dark.png": 889,
	"./tsm.png": 890,
	"./tsm_dark.png": 891
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2054;



//////////////////
// WEBPACK FOOTER
// ./res/images/subscription ^\.\/.*\.png$
// module id = 2054
// module chunks = 0